import { render } from "./FlushAccordion.vue?vue&type=template&id=5d8e7c78"
import script from "./FlushAccordion.vue?vue&type=script&lang=js"
export * from "./FlushAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__